import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "Components/Search Results",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-search-results",
    args: {
        category: "aaaa",
        url: "sss",
    },
    argTypes: {
        category: {
            control: "string",
        },
        url: {
            control: "string",
        },
    },
};

const Template = ({ category, url }) => html`
    <ux-iws-search-results
        category="${category}"
        url="${url}"
    ></ux-iws-search-results>
`;

export const Default = Template.bind({});
Default.args = {
    category: "all",
    url: "./mock-data/website-search-results_c-all.html",
};
